import { render, staticRenderFns } from "./PlotterHeader.vue?vue&type=template&id=36049aee&"
import script from "./PlotterHeader.vue?vue&type=script&lang=js&"
export * from "./PlotterHeader.vue?vue&type=script&lang=js&"
import style0 from "./PlotterHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports